import React, { useState } from "react";

function SantaClaraShowHide() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="junk-santa">
        <h3>Serving Santa Clara, CA and Surrounding Areas</h3>
        <div className="sliderline-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="4"
            viewBox="0 0 64 4"
            fill="none"
          >
            <path
              d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
              fill="#60BDFF"
            ></path>
          </svg>
        </div>
      </div>

      <div className="junk-santa-desc">
        <p>
          We proudly serve Santa Clara, Mountain View, Palo Alto, Menlo Park,
          San Jose and surrounding cities in Santa Clara County. Whether you
          need junk removal from your home, office, or a construction site, we
          are here to help you reclaim your space quickly and affordably.
        </p>
      </div>

      {isExpanded && (
        <div>
          <div className="pt-0 junk-santa-desc milpitas-list">
            <h3>Get Your Junk Removal Estimate in Santa Clara, CA Today!</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p>
              Need junk removal in Santa Clara, CA? Contact Junk Droid for a
              free estimate and to schedule your same-day service. We’re your
              trusted team for fast, affordable, and eco-friendly junk removal.
            </p>
            <h3>Contact Junk Droid for Junk Removal in Santa Clara, CA</h3>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="4"
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                ></path>
              </svg>
            </div>
            <p>
              Call us at <a href="tel:+4085397261">(408) 539-7261</a> or book
              online for junk removal service in Santa Clara, CA. Whether it’s
              furniture removal, construction debris, or a full cleanout, our
              professional team will take care of all your junk removal needs.
            </p>
          </div>
        </div>
      )}

      <button className="btn btn-read" onClick={toggleText}>
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default SantaClaraShowHide;
